import { useFilterData } from "./useFilterData";
import { useGetParkStockData } from "./useGetParkStockData";

export const useFilteredCaravanStock = () => {
  const { data: caravanStock } = useGetParkStockData();
  const { filterData } = useFilterData();

  const filteredCaravanStock = filterData(caravanStock || []);
  return { filteredCaravanStock };
};
